import React from 'react';
import { Table } from 'semantic-ui-react';
import DataManagementDictionaryButtonGroup from './DataManagementDictionaryButtonGroup';

const DataManagementDictionaryActionsCell = ({
  allowConversion,
  convert,
  dictionaryCode,
  dictionaryName,
  disableConvert,
  disableValidate,
  isLoading,
  validate,
}) => (
  <Table.Cell singleLine textAlign="center">
    <DataManagementDictionaryButtonGroup
      allowConversion={allowConversion}
      convert={convert}
      dictionaryCode={dictionaryCode}
      dictionaryName={dictionaryName}
      disableConvert={disableConvert || isLoading}
      disableValidate={disableValidate || isLoading}
      validate={validate}
    />
  </Table.Cell>
);
export default DataManagementDictionaryActionsCell;
